import { render, staticRenderFns } from "./NewRadioButtonGroup.vue?vue&type=template&id=150a7318&scoped=true"
import script from "./NewRadioButtonGroup.vue?vue&type=script&lang=ts"
export * from "./NewRadioButtonGroup.vue?vue&type=script&lang=ts"
import style0 from "./NewRadioButtonGroup.vue?vue&type=style&index=0&id=150a7318&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150a7318",
  null
  
)

export default component.exports